export const getPageClass = ( uri, menuOpened ) => {
  let [ lang, page, subpage, alpha ] = uri.substr( 1 ).split( '/' ),
      classes = [ 'page-container' ]

  if( lang === '.alpha' ) {
    lang = page
    page = subpage
    subpage = alpha
  }

  classes.push( lang )

  switch( page ) {
    case "contact": case "contato":
        const themes = [ "pink", "dark-red", "dark-green" ]
          //idx = Math.floor( Math.random() * themes.length )

        classes.push( page )
        classes.push( themes[ 1 ] ) //trocar 1 por idx, para deixar as cores variando aleatoriamente
      break;
    case "cases":
      classes.push( 'single-case' )
      classes.push( subpage )
      break;
    default:
      classes.push( page || "home" )
      break;
  }

  if( menuOpened ) classes.push( 'menu-opened' )

  return classes.join( ' ' )
}

